<script lang="ts">
	import Questions from "./components/Questions.svelte";
	import { Router, Route } from "./routing";
	import SearchResults from "./components/SearchResults.svelte";
	import About from "./components/About.svelte";
	import Privacy from "./components/Privacy.svelte";
	import Landing from "./components/Landing.svelte";
	import Onboarding from "./components/Onboarding.svelte";
	import Menubar from "./components/Menubar.svelte";
	import NotFound from "./components/NotFound.svelte";
	import "./global.scss";
	import { Any, dict, S, union } from "./combinators";
	import type { RouteResort, RouteSearch, RouteSettings, RouteToplist } from "./search_routing";
	import { toplistCriteriaParser } from "./toplist_criteria";
	import AllResorts from "./components/AllResorts.svelte";

	export let url = "";

	const basicParser = union<RouteToplist | RouteResort | RouteSearch>([
		dict({
			_: S("topplistor"),
			property: toplistCriteriaParser,
			location: Any(),
			resort: Any(),
		}).map((x) => ({ type: "toplist", ...x })),
		dict({
			_: S("topplistor"),
			property: toplistCriteriaParser,
			location: Any(),
		}).map((x) => ({ type: "toplist", resort: null, ...x })),
		dict({
			_: S("topplistor"),
			property: toplistCriteriaParser,
		}).map((x) => ({
			type: "toplist",
			location: null,
			resort: null,
			...x,
		})),
		dict({
			_: S("skidort"),
			resort: Any(),
		}).map((x) => ({ type: "resort", ...x })),
		S("sök").map((_) => ({ type: "search" })),
	]);

	let searchResultsRoute = union<RouteToplist | RouteResort | RouteSearch | RouteSettings>([
		basicParser.skip(S("inställningar")).map((parent) => ({
			type: "settings",
			parent,
		})),
		basicParser,
	]);
</script>

<Router {url}>
	<Menubar />
	<Route path={S("om-oss")} let:location>
		<About />
	</Route>
	<Route path={S("integritetspolicy")} let:location>
		<Privacy />
	</Route>
	<Route path={S("start")} let:location>
		<Onboarding {location} />
	</Route>
	<Route path={S("skidorter")} let:location>
		<AllResorts />
	</Route>
	<Route path={S("")} let:location>
		<Landing />
	</Route>
	<Route path={searchResultsRoute} let:params let:location>
		<SearchResults parsedUrl={params} {location} />
	</Route>
	<Route>
		<NotFound />
	</Route>
</Router>

<style>
	:global(body) {
		padding: 0px;
	}
</style>
